import './UnderwritingMultiTenant.scss';
import Component from './UnderwritingMultiTenant.js';
export default Component;
